import React from 'react';
import { motion } from 'framer-motion';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="w-full bg-[#F8F6F3] py-20 px-8 md:px-16 lg:px-24" style={{
    boxShadow: 'inset 0 1px 0 rgba(0,0,0,0.06)'
  }} data-id="element-73">
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start md:items-end gap-12" data-id="element-74">
        <div className="flex flex-col gap-6" data-id="element-75">
          <h3 className="text-2xl font-bold text-[#1A1A1A]" data-id="element-76">JP Davidson</h3>
          <div className="flex flex-col gap-2" data-id="element-77">
            <div className="flex gap-6 mt-2" data-id="element-78">
              <a href="#" className="text-[#6B6560] hover:text-[#1A1A1A] transition-colors" data-id="element-79">
                LinkedIn
              </a>
            </div>
          </div>
        </div>

        <div className="text-[#6B6560] text-sm" data-id="element-80">
          &copy; {currentYear} JP Davidson. All rights reserved.
        </div>
      </motion.div>
    </footer>;
}